<div
    *ngIf="taskGroupItem.taskType === TaskGroupItemType.CollectingTask"
    dynamic-collecting-task-item
    [task]="taskGroupItem.task"
    [badgeText]="badgeText"
    [groupCollapsed]="groupCollapsed"
    class="col-12 dynamic-task-column"
></div>
<div
    *ngIf="
        taskGroupItem.taskType === TaskGroupItemType.DeliveringTask &&
        (!IsContainer || IsExtraDelivery)
    "
    dynamic-delivering-task-item
    [task]="taskGroupItem.task"
    [badgeText]="badgeText"
    [groupCollapsed]="groupCollapsed"
    class="col-12 dynamic-task-column"
></div>
<div
    *ngIf="
        taskGroupItem.taskType === TaskGroupItemType.DeliveringTask &&
        IsContainer &&
        !IsExtraDelivery
    "
    delivery-container-placing-task-item
    [task]="taskGroupItem.task"
    class="col-12 col-sm-6 col-lg-4 mb-md-2 m-auto"
></div>
<div
    *ngIf="taskGroupItem.taskType === TaskGroupItemType.RefundingTask"
    refunding-task-item
    [task]="taskGroupItem.task"
    [badgeText]="badgeText"
    [groupCollapsed]="groupCollapsed"
    class="col-12 dynamic-task-column"
></div>
<div
    *ngIf="taskGroupItem.taskType === TaskGroupItemType.ContainerPlacingTask"
    container-placing-task-item
    [task]="taskGroupItem.task"
    class="col-12 col-sm-6 col-lg-4 mb-md-2 m-auto"
></div>
